<template>
  <div class="browse">
    <div class="browse_nav">
      <div class="browse_left">
        <div class="evolution_left_txt">
          <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
          <div class="evolution_txt" style="cursor: pointer;" @click="tiao">
            首页 <span class="span1">></span> <span class="span2">期刊目录</span>
          </div>
        </div>
        <div class="browse_top">
          <div class="browse_left2">

            <div class="browse_kuai" @click="aaa()">
              <img :src="titlePhoto" alt="">
              <div class="browse_title">{{ year1 }}年{{ volume }}卷{{ issue }}期</div>
            </div>

            <div class="dang">当前一期</div>
          </div>
          <div class="browse_right2" @mouseenter="on_bot_enter" @mouseleave="on_bot_leave">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in imgList" :key="index">
                  <div style="overflow: hidden;width: 95%;margin: 0 auto;cursor: pointer;">

                    <div class="browse_kuai" @click="bbb(item)">
                      <img :src="item.titlePhoto" alt="">
                      <div class="browse_title">{{ item.year }}年{{ item.volume }}卷{{ item.issue }}期</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="new">最新过刊</div>
          </div>
        </div>
        <div class="browse_bottom">
          <div class="browse_bottom1">
            <div class="zuobiao" @click="left2" :class="jia3 ? 'addxuan2' : ''" @mouseover="xuan3(1)"
              @mouseout="xuan3(2)">
            </div>
            <div class="browse_bottomnav">
              <el-carousel trigger="click" indicator-position="none" :autoplay="false" ref="car2" @change="changeFun2">
                <el-carousel-item v-for="(item, index) in iconsArr2" :key="index">
                  <div class="dao" v-for="(item2, index2) in item" :key="index2" @click="dianyear(item2.year, index2)">
                    <div class="browse_shijian" :class="item2.zt ? 'addtime' : ''">{{ item2.year }}</div>
                    <div class="browse_dian" :class="item2.zt ? 'addtime2' : ''"></div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="youbiao" @click="right2" :class="jia4 ? 'addxuan2' : ''" @mouseover="xuan4(1)"
              @mouseout="xuan4(2)">></div>
          </div>
          <div class="browse_bottom2">
            <div class="browse_bottom2top">
              <div v-for="(item, index) in year" :key="index" class="browse_year" :class="item.zt ? 'addtime' : ''"
                @click="dianyear2(item.year, index)">
                {{ item.year }}
                <!-- <div class="sanjiao" v-if="item.zt">▼</div> -->
              </div>
            </div>
          </div>
          <div class="browse_bottom3">
            <div class="browse_bottom3nav">
              <div v-for="(item, index) in year2" :key="index" class="browse_year2" :class="item.zt ? 'addyear' : ''"
                @click="dianqi(index)">
                第{{ item.issue }}期
              </div>
            </div>
          </div>
        </div>
        <div class="browse_list">
          <div class="author_nav2r">
            <div style="marginBottom:30px">
              <!-- <div style="marginTop:2px;float:left;marginRight:15px" >

                <img src="../../assets/个案报告.png" alt="">
              </div>

            <span style="width: 96px;
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #2A2D3E;
            line-height: 33px;">个案报告
            </span> -->
            </div>

            <div class="author_list2" v-for="(item, index) in list" :key="index" @mouseover="addtop(1, item.id)"
              @mouseout="addtop(2, item.id)" @click="jumpxq(item.id)">
              <div class="author_wen">
                <!-- <div class="wen11" v-if="item.channelName!='' && item.channelName!=null"><div class="author_dian add2"></div>{{item.channelName}}</div> -->
                <div class="wen1" :class="item.zt ? 'add1' : ''">{{ item.title }}</div>
                <div class="wen2">{{ item.authors }}</div>
              </div>

              <div class="zhai">
                <div class="wen3">
                  {{ item.yearVolumeIssue }}&nbsp;&nbsp;&nbsp;&nbsp;
                  下载次数：<span>{{ item.downloads }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                  引用频次：<span>{{ item.htmlHits }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                  阅读次数：<span>{{ item.hits }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                  网刊下载次数：<span>{{ item.downloads }}</span>
                </div>
                <div class="clickA" style="width: 16%;float: right;">
                  <div class="zhai_left"><span style="margin-right: 8px;"> <img src="../../assets/摘要.png" alt="">
                    </span>

                  </div>
                  <div class="zhai_right" @click.stop="down(item.id)"><span style="margin-right: 8px;"> <img
                        src="../../assets/下载.png" alt=""></span>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="curr"
          :page-size="limit" layout="prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>

      <div class="browse_right">
        <advertisement :num="num" :list2="list2"></advertisement>
      </div>

    </div>
  </div>
</template>
<script>
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components: {
    advertisement,
  },
  data() {
    return {
      currYearIndex:0,
      isVolume: '',
      isYear: '',
      imgList: [],
      curr: 1,
      limit: 10,
      swiper: null,
      iconsArr: [],
      iconsArr2: [],
      list: [],//过刊浏览 列表数据
      total: 0,//总条数
      time: [],
      zuo: false,
      you: true,
      zuo2: false,
      you2: true,
      zidong: true,
      jia: false,
      jia2: false,
      jia3: false,
      jia4: false,
      titlePhoto: null,
      year1: null,
      volume: null,
      issue: null,
      issuecid: null,
      year: [],//过刊浏览页 获取杂志社的年限
      year2: [],//过刊浏览页 获取杂志社的年限下的所出期刊数
      chart: [],//年卷期
      num: {
        wai: false,
        zixun: true,
        xia: true,
        look: false,
        video2: true,
      },//控制广告栏的显示隐藏
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
        }
      ],//外科天地
    }
  },
  methods: {
    down(contentId) {
      var that = this;
      that.$httphelper.GetContentFilePath({
        "journalId": 201607080003,
        "contentId": contentId,
        "downType": 1
      }).then(res => {
        if (res.code == 200) {
          window.open(res.data);
          that.$loading.hideLoading();
        } else {
          that.$alert('没有附件', '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    tiao() {
      this.$router.push({ path: '/home' });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.curr = val;
      var year;
      var issue;
      for (var i = 0; i < this.year.length; i++) {
        if (this.year[i].zt) {
          year = this.year[i].year;
        }
      }
      for (var i = 0; i < this.year2.length; i++) {
        if (this.year2[i].zt) {
          issue = this.year2[i].issue;
        }
      }
      this.GetBackIssueBrowsing(year, issue);
      console.log(`当前页: ${val}`);
    },
    //过刊浏览页 当年的年卷期和封面
    GetThatYearIssueList(year) {
      var that = this;
      that.$httphelper.GetThatYearIssueList({
        "journalId": 201607080003,
        'year': year
      }).then(res => {
        if (res.code == 200) {
          console.log(res.data, '123123123')
          that.chart = res.data || '';
          that.arrTrans(5, that.chart, 1) //num个数  arr数组
          for (var i = 0; i < that.chart.length; i++) {
            if (that.chart[i].status == 1) {
              console.log(that.chart[i], '123123')

              that.titlePhoto = that.chart[i].titlePhoto;
              that.year1 = that.chart[i].year;
              that.volume = that.chart[i].volume;
              that.issue = that.chart[i].issue;
              that.issuecid = that.chart[i].issuecid
            }
          }
        } else {
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //过刊浏览页 获取杂志社的间隔年限
    GetJournalGapYear() {
      var that = this;
      that.$httphelper.GetJournalGapYear({
        "journalId": 201607080003,
        'gapYear': 10
      }).then(res => {
        if (res.code == 200) {
          that.time = res.data || '';
          if (that.$route.query.year && that.$route.query.issue) {
            for (var i = 0; i < that.time.length; i++) {
              if (i == 0) {
                that.time[i].zt = true;
                that.time.push('1');
                that.time.pop('1');
              } else {
                that.time[i].zt = false;
                that.time.push('1');
                that.time.pop('1');
              }
            }
          } else {
            for (var i = 0; i < that.time.length; i++) {
              if (i == 0) {
                that.time[i].zt = true;
                that.time.push('1');
                that.time.pop('1');
              } else {
                that.time[i].zt = false;
                that.time.push('1');
                that.time.pop('1');
              }
            }
          }
          that.arrTrans(10, that.time, 2) //num个数  arr数组
          setTimeout(function () {
            if (that.$route.query.year && that.$route.query.issue) {
              for (var i = 0; i < that.iconsArr2[0].length; i++) {
                if((that.iconsArr2[0][i].year-that.$route.query.year)<=10&&(that.iconsArr2[0][i].year-that.$route.query.year)>=0){
                  that.GetJournalYear(that.iconsArr2[0][i].year);
                }
                // for (var j = 0; j < that.iconsArr2[0].length; j++) {
                  
                //   that.GetJournalYear(that.iconsArr2[0][j].year);
                //   if (that.$route.query.year <= that.iconsArr2[0][j]?.year && that.$route.query.year > that.iconsArr2[0][j + 1].year) {
                //     console.log(that.$route.query.year,that.iconsArr2[0][j],'lll')
                //     that.GetJournalYear(that.iconsArr2[0][j].year);
                //   }
                // }
              }
            } else {
              //过刊浏览页 获取杂志社的年限
              that.GetJournalYear(that.time[0].year);
            }
          }, 100)
        } else {
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //过刊浏览页 获取杂志社的年限
    GetJournalYear(year) {
      console.log(year,'年份')
      var that = this;
      that.$httphelper.GetJournalYear({
        "journalId": 201607080003,
        "year": year,
        "gapYear": 10,
      }).then(res => {
        if (res.code == 200) {
          that.year = res.data || '';
          //过刊浏览页 获取杂志社的年限下的所出期刊数
          that.GetJournalIssueList(year);
          if (that.$route.query.year && that.$route.query.issue) {
            for (var i = 0; i < this.iconsArr2[0].length; i++) {
              if (this.iconsArr2[0][i].year == year) {
                this.iconsArr2[0][i].zt = true;
                this.iconsArr2[0].push('1');
                this.iconsArr2[0].pop('1');
              } else {
                this.iconsArr2[0][i].zt = false;
                this.iconsArr2[0].push('1');
                this.iconsArr2[0].pop('1');
              }
            }
          } else {
            for (var i = 0; i < that.year.length; i++) {
              if (i == 0) {
                that.year[i].zt = true;
                that.year.push('1');
                that.year.pop('1');
              } else {
                that.year[i].zt = false;
                that.year.push('1');
                that.year.pop('1');
              }
            }
          }
        } else {
          // that.$alert(res.msg, '提示', {
          //   confirmButtonText: '确定',
          //   callback: action => {

          //   }
          // });
        }
      });
    },
    aaa() {
      console.log(this.issuecid)
    },
    bbb(item) {
      console.log(item)

    },
    //过刊浏览页 获取杂志社的年限下的所出期刊数
    GetJournalIssueList(year) {
      var that = this;
      that.$httphelper.GetJournalIssueList({
        "journalId": 201607080003,
        "year": this.currYearIndex,
      }).then(res => {
        if (res.code == 200) {
          that.year2 = res.data || '';
          if (that.$route.query.year && that.$route.query.issue) {
            //获取过刊浏览 列表数据
            that.GetBackIssueBrowsing(that.$route.query.year, that.$route.query.issue);
            for (var i = 0; i < that.year.length; i++) {
              if (that.year[i].year == that.$route.query.year) {
                that.year[i].zt = true;
                that.year.push('1');
                that.year.pop('1');
              } else {
                that.year[i].zt = false;
                that.year.push('1');
                that.year.pop('1');
              }
            }
            for (var i = 0; i < that.year2.length; i++) {
              if (that.year2[i].issue == that.$route.query.issue) {
                that.year2[i].zt = true;
                that.year2.push('1');
                that.year2.pop('1');
              } else {
                that.year2[i].zt = false;
                that.year2.push('1');
                that.year2.pop('1');
              }
            }
          } else {
            //获取过刊浏览 列表数据
            that.GetBackIssueBrowsing(year, that.year2[0].issue);
            for (var i = 0; i < that.year2.length; i++) {
              if (i == 0) {
                that.year2[i].zt = true;
                that.year2.push('1');
                that.year2.pop('1');
              } else {
                that.year2[i].zt = false;
                that.year2.push('1');
                that.year2.pop('1');
              }
            }
          }
        } else {
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //获取过刊浏览 列表数据
    GetBackIssueBrowsing(year, issue) {
      var that = this;
      that.$httphelper.GetBackIssueBrowsing({
        "journalId": 201607080003,
        "year": Number(year),
        "issue": Number(issue),
        "curr": that.curr,
        "limit": that.limit,
      }).then(res => {
        if (res.code == 200) {
          that.list = res.data || '';
          that.total = res.totalcount;
        } else {
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
        that.$loading.hideLoading();
      });
    },

    //点击年份
    dianyear(year, index2) {
      this.$route.query.year = '';
      this.currYearIndex = year
      this.GetJournalYear(year);
      for (var i = 0; i < this.iconsArr2[0].length; i++) {
        if (i == index2) {
          this.iconsArr2[0][i].zt = true;
          this.iconsArr2[0].push('1');
          this.iconsArr2[0].pop('1');
        } else {
          this.iconsArr2[0][i].zt = false;
          this.iconsArr2[0].push('1');
          this.iconsArr2[0].pop('1');
        }
      }
    },
    //点击年份2
    dianyear2(year, index) {
      this.$route.query.year = '';
      this.currYearIndex=year
      this.GetJournalIssueList(year);
      console.log(this.year, 'this.year')
      for (var i = 0; i < this.year.length; i++) {
        if (i == index) {
          this.year[i].zt = true;
          this.year.push('1');
          this.year.pop('1');
        } else {
          this.year[i].zt = false;
          this.year.push('1');
          this.year.pop('1');
        }
      }
    },
    //点击期数
    dianqi(index) {
      this.$route.query.year = '';
      var that = this;
      var year;
      for (var i = 0; i < this.year.length; i++) {
        if (this.year[i].zt) {
          year = this.year[i].year;
          this.GetBackIssueBrowsing(year, that.year2[index].issue);
        }
      }
      for (var i = 0; i < that.year2.length; i++) {
        if (i == index) {
          that.year2[i].zt = true;
          that.year2.push('1');
          that.year2.pop('1');
        } else {
          that.year2[i].zt = false;
          that.year2.push('1');
          that.year2.pop('1');
        }
      }
    },
    //页面初始化
    index() {
      this.$loading.showLoading();
      sessionStorage.setItem('routerIndex', 4);
      var that = this;
      var date = new Date();
      var year = date.getFullYear();
      //过刊浏览页 当年的年卷期和封面
      this.GetThatYearIssueList(Number(this.$route.query.year)||year);
      //过刊浏览页 获取杂志社的间隔年限
      this.GetJournalGapYear();


    },
    arrTrans(num, arr, type) { // 一维数组转换为二维数组
      const iconsArr = []; // 声明数组
      arr.forEach((item, index) => {
        const page = Math.floor(index / num); // 计算该元素为第几个素组内
        if (!iconsArr[page]) { // 判断是否存在
          iconsArr[page] = [];
        }
        iconsArr[page].push(item);
        if (type == 1) {
          this.iconsArr = iconsArr;
        } else {
          this.iconsArr2 = iconsArr;
        }
      });
    },
    //轮播图上一页
    left() {
      if (this.zuo) {
        this.$refs.car.prev();
      }
    },
    //轮播图下一页
    right() {
      if (this.you) {
        this.$refs.car.next();
      }
    },
    //轮播图上一页
    left2() {
      if (this.zuo2) {
        this.$refs.car2.prev();
      }
    },
    //轮播图下一页
    right2() {
      if (this.you2) {
        this.$refs.car2.next();
      }
    },
    //控制翻页按钮样式改变
    changeFun(e) {
      console.log(e, 'e')
      var num = this.iconsArr.length;
      if (num == 1) {
        this.zuo = false;
        this.you = false;
      } else if (e == num - 1) {
        this.zuo = true;
        this.you = false;
      } else if (e == 0) {
        this.zuo = false;
        this.you = true;
      }
    },
    //控制翻页按钮样式改变
    changeFun2(e) {
      var num = this.iconsArr2.length;
      if (num == 1) {
        this.zuo2 = false;
        this.you2 = false;
      } else if (e == num - 1) {
        this.zuo2 = true;
        this.you2 = false;
      } else if (e == 0) {
        this.zuo2 = false;
        this.you2 = true;
      }
    },
    on_bot_enter() {
      this.swiper.autoplay.stop();
    },
    on_bot_leave() {
      this.swiper.autoplay.start();
    },
    //悬停箭头停止自动滚动
    xuan(id) {
      if (id == 1) {
        this.zidong = false;
        this.jia = true;
      } else {
        this.zidong = true;
        this.jia = false
      }
    },
    //悬停箭头停止自动滚动
    xuan2(id) {
      if (id == 1) {
        this.zidong = false;
        this.jia2 = true;
      } else {
        this.zidong = true;
        this.jia2 = false
      }
    },
    //悬停箭头停止自动滚动
    xuan3(id) {
      if (id == 1) {
        this.jia3 = true;
      } else {
        this.jia3 = false
      }
    },
    //悬停箭头停止自动滚动
    xuan4(id) {
      if (id == 1) {
        this.jia4 = true;
      } else {
        this.jia4 = false
      }
    },
    //鼠标悬停
    addtop(num, id) {
      if (num == 1) {
        for (var i = 0; i < this.list.length; i++) {
          if (id == this.list[i].id) {
            this.list[i].zt = true;
            this.list.push('1');
            this.list.pop('1');
          }
        }
      } else {
        for (var i = 0; i < this.list.length; i++) {
          this.list[i].zt = false;
          this.list.push('1');
          this.list.pop('1');
        }
      }
    },
    //跳转文章
    jumpxq(id) {
      var year;
      var issue;
      for (var i = 0; i < this.year.length; i++) {
        if (this.year[i].zt) {
          year = this.year[i].year;
        }
      }
      for (var i = 0; i < this.year2.length; i++) {
        if (this.year2[i].zt) {
          issue = this.year2[i].issue;
        }
      }
      console.log(year, issue, id)
      this.$router.replace({query: { year: year, issue: issue, issuecid: id } }).then(res=>{
        this.$router.push({ path: '/browse_details', query: { year: year, issue: issue, issuecid: id } });
      })
     
    },
    currYear() {
      this.$httphelper.GetGuoqiData({
        "journalId": 201607080003,
      }).then(res => {

      console.log(res,'好好好')
        this.imgList = res.data[0].issueLists.reverse().slice(0, this.issue).map(item=>{
          return {
            ...item,
            year:res.data[0].year,
             volume:res.data[0].volume||res.data[0].dispayName.split('.')[1]
          }
        })
        if (this.imgList.length < 5) {
          let data = res.data[1].issueLists.map(item => {
            return {
             ...item,
             year:res.data[1].year,
             volume:res.data[1].volume||res.data[1].dispayName.split('.')[1]
            }
          })
          this.imgList = [...this.imgList, ...data]
        }
        console.log(this.imgList, '嘿嘿')
 
        console.log(this.isVolume)
      })
    }
  },
  mounted() {
    this.swiper = new Swiper('.swiper-container', {
      slidesPerView: 6,
      spaceBetween: 30,
      loop: true,
      slidesPerView: 'auto',
      loopedSlides: 5,
      speed: 2500,//匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      observer: true,//修改swiper自己或子元素时，自动初始化swiper
      observeParents: true//修改swiper的父元素时，自动初始化swiper
    });
  },
  created() {
    this.index();
    this.currYear()
    var date = new Date();
    var year = date.getFullYear();
    this.currYearIndex = Number(this.$route.query.year||year)
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.browse {
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;

  .browse_nav {
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    margin-top: 24px;
    padding-bottom: 49px;

    .browse_left {
      width: 73%;
      margin-right: 2%;
      float: left;

      .evolution_left_txt {
        width: 100%;
        overflow: hidden;
        margin-bottom: 25px;

        .evolution_tu {
          width: 19px;
          height: 17px;
          float: left;
        }

        .evolution_txt {
          float: left;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #010101;

          .span1 {
            margin: 0 5px;
          }

          .span2 {
            color: var(--xt);
          }
        }
      }

      .browse_top {
        width: 100%;
        overflow: hidden;

        .browse_left2 {
          width: 18%;
          float: left;
          margin-right: 1%;
          background: #F5F7F8;
          padding-top: 28px;
          padding-bottom: 68px;
          position: relative;

          .browse_kuai {
            width: 132px;
            margin: 0 auto;
            text-align: center;
            cursor: pointer;

            img {
              width: 100%;
              height: 176px;
              margin-bottom: 17px;
            }

            img:hover {
              transform: scale(1.03);
            }

            .browse_title,
            .browse_time {
              width: 100%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: bold;
              color: #000000;
              line-height: 24px;
            }

            .browse_time {
              font-size: 13px;
              color: #5F5F5F;
            }
          }

          .dang {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            text-align: center;
            line-height: 38px;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            color: #000000;
            background-color: #EEEEEE;
          }
        }

        .browse_right2 {
          width: 81%;
          float: left;
          overflow: hidden;
          background: #F5F7F8;
          padding-top: 28px;
          padding-bottom: 14px;
          position: relative;

          /deep/ .el-carousel__arrow {
            display: none;
          }

          .new {
            width: 100%;
            background: #EEEEEE;
            line-height: 38px;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            color: #000000;
            text-align: center;
            position: absolute;
            bottom: 0;
            left: 0;
          }

          .new_left,
          .new_right {
            width: 38px;
            line-height: 38px;
            z-index: 10;
            background-color: #AAAAAA;
            color: #FFFFFF;
            font-size: 18px;
            font-weight: bold;
            bottom: 0;
            text-align: center;
            cursor: pointer;
          }

          .new_left {
            position: absolute;
            left: 0;
          }

          .new_right {
            position: absolute;
            right: 0;
          }

          .browse_kuai {
            width: 132px;
            margin: 0 auto;
            text-align: center;
            float: left;
            margin-right: 3%;

            img {
              width: 100%;
              height: 176px;
              margin-bottom: 17px;
            }

            img:hover {
              transform: scale(1.03);
            }

            .browse_title,
            .browse_time {
              width: 100%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: bold;
              color: #000000;
              line-height: 24px;
            }

            .browse_time {
              font-size: 13px;
              color: #5F5F5F;
            }
          }

          .browse_kuai:last-child {
            margin-right: 0;
          }
        }
      }

      .browse_bottom {
        margin-top: 26px;
        width: 100%;
        overflow: hidden;

        .browse_bottom1 {
          width: 100%;
          border-bottom: 1px solid var(--biao);
          height: 43px;

          .zuobiao {
            width: 12px;
            height: 20px;
            color: #B9B9B9;
            float: left;
            font-size: 25px;
            cursor: pointer;
          }

          .browse_bottomnav {
            width: 90%;
            margin: 0 auto;
            margin-left: 4%;
            float: left;
            overflow: hidden;

            /deep/ .el-carousel__container {
              height: 50px;
            }

            .dao {
              width: 11.11%;
              float: left;
              position: relative;
              cursor: pointer;

              .browse_shijian {
                width: 80%;
                height: 27px;
                margin: 0 auto;
                text-align: center;
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: bold;
                color: #000000;
                line-height: 27px;
              }

              .browse_dian {
                width: 11px;
                height: 11px;
                border: 1px solid #BDBDBD;
                border-radius: 50%;
                position: absolute;
                bottom: -23px;
                left: 50%;
                margin-left: -5.5px;
                z-index: 1;
                background-color: #BDBDBD;
              }
            }
          }

          .youbiao {
            width: 12px;
            height: 20px;
            float: right;
            color: #B9B9B9;
            font-size: 25px;
            margin-right: 10px;
            cursor: pointer;
          }
        }

        .browse_bottom2 {
          width: 100%;
          height: 38px;
          background: #EEEEEE;
          margin-top: 15px;

          .browse_bottom2top {
            width: 90%;
            height: 38px;
            margin: 0 auto;

            .browse_year {
              width: 10%;
              float: left;
              text-align: center;
              line-height: 38px;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #6A6A6A;
              cursor: pointer;
              position: relative;

              .sanjiao {
                color: var(--biao);
                position: absolute;
                bottom: -24px;
                left: 50%;
                margin-left: -7px;
              }
            }
          }
        }

        .browse_bottom3 {
          width: 100%;
          background-color: #FAFAFA;

          .browse_bottom3nav {
            width: 80%;
            margin: 0 auto;
            overflow: hidden;
            padding-top: 27px;
            padding-bottom: 10px;

            .browse_year2 {
              width: 12.2%;
              margin-right: 5%;
              float: left;
              line-height: 28px;
              text-align: center;
              color: #BDBDBD;
              border: 1px solid #BDBDBD;
              margin-bottom: 17px;
              font-weight: bold;
              cursor: pointer;
            }

            .browse_year2:nth-child(6n) {
              margin-right: 0;
            }
          }
        }
      }

      .browse_list {
        width: 100%;
        overflow: hidden;
        margin-top: 30px;

        .author_nav2r {
          width: 100%;
          float: left;
          overflow: hidden;

          .author_list2 {
            width: 100%;
            overflow: hidden;
            cursor: pointer;
            margin-bottom: 30px;
            border-bottom: 1px solid #EBEBEB;
            padding-bottom: 23px;

            .author_wen {
              width: 80%;
              float: left;

              .wen11 {
                font-size: 16px;
                font-family: Source Han Sans SC;
                font-weight: bold;
                color: #000000;
                margin-bottom: 11px;

                .author_dian {
                  width: 10px;
                  height: 10px;
                  background: #DBDBDB;
                  border-radius: 50%;
                  margin-right: 21px;
                  float: left;
                  margin-top: 6px;
                }
              }

              .wen1 {
                width: 100%;
                font-size: 24px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;
                margin-bottom: 20px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }

              .wen2 {
                width: 100%;
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #636363;
                margin-bottom: 25px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }

            .zhai {
              width: 100%;
              overflow: hidden;
              float: left;

              .wen3 {
                width: 84%;
                float: left;
                font-size: 14px;
                // margin-top: 20px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #636363;

                span {
                  color: #FF8813;
                }
              }

              .zhai_left,
              .zhai_right {
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;
                float: right;

              }

              .zhai_right {
                margin-left: 20px;
                margin-right: 2px;
              }

              .zhai_left:hover {
                text-decoration: underline;
                color: var(--biao);
              }

              .zhai_right:hover {
                text-decoration: underline;
                color: var(--biao);
              }
            }
          }
        }
      }

      .el-pagination {
        text-align: center;
        margin-top: 30px;
      }
    }

    .browse_right {
      width: 25%;
      float: left;
      margin-top: 20px;
    }
  }
}

.addxuan {
  background-color: var(--xt) !important;
}

.addxuan2 {
  color: var(--biao) !important;
}

/deep/ .el-carousel__arrow {
  display: none;
}

.addtime {
  background-color: #E60112 !important;
  color: #FFFFFF !important;
}

.addtime2 {
  background-color: #E60112 !important;
  border: 1px solid #E60112 !important;
}

.addyear {
  border: 1px solid #E60112 !important;
  color: #E60112 !important;
}

.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
  background-color: var(--xt) !important;
}

.swiper-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .swiper-wrapper {
    width: 95% !important;
    width: auto;
    margin: 0 auto;
    cursor: pointer;
    padding-bottom: 53px !important;
    -webkit-transition-timing-function: linear !important;
    /*之前是ease-out*/
    -moz-transition-timing-function: linear !important;
    -ms-transition-timing-function: linear !important;
    -o-transition-timing-function: linear !important;
    transition-timing-function: linear !important;

    .swiper-slide {
      width: 19% !important;
      margin: 0 auto;
      text-align: center;
      float: left;
      margin-right: 3%;
    }
  }
}

.seamless-warp2 {
  overflow: hidden;
  height: 250px;

  .retrieval_banner {
    overflow: hidden;
    list-style: none;
    padding: 39px 0 44px 0;

    li {
      width: 255px;
      margin-right: 20px;
      float: left;
      text-align: center;
      background: #FFFFFF;

      img {
        width: 100%;
        height: 58px;
        margin-bottom: 35px;
        display: flex;
        border: 1px solid #EDEDED;
      }

      .retrieval_txt {
        height: 16px;
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #151515;
        line-height: 6px;
      }

      .retrieval_txt:hover {
        color: var(--xt) !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nav/browse.vue